import { useEffect } from 'react';

/** Imposta document.title e la meta description della pagina corrente
 * (SEO on-page, richiesta da doc "DTK_Contenuti_Web_SEO_v1"). Nessuna
 * libreria esterna: gestisce direttamente il tag <title> e <meta
 * name="description"> nel <head>, ripristinando i valori precedenti
 * all'unmount (utile in dev/StrictMode con doppio mount). */
export function useSeo(title: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDescription = meta?.getAttribute('content') ?? null;
    if (description) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    return () => {
      document.title = prevTitle;
      if (description && meta && prevDescription !== null) {
        meta.setAttribute('content', prevDescription);
      }
    };
  }, [title, description]);
}
